// content_edit.js

const CONFIG = {
    gridcols: 3,
    gridrows: 5,
    firstLoad: true,
}

$(document).ready(function () {
    initForms();
    initTinyMCE();
    initHot();

    CONFIG.firstLoad = false;

});

function initForms() {
    // Enable "diry form" checking on the form
    $('form').areYouSure();
}

// init the tinymce forms
function initTinyMCE() {
    tinymce.PluginManager.add('stylebuttons', function(editor, url) {
      ['h1', 'h2', 'h3', 'h4', 'h5'].forEach(function(name){
       editor.addButton("style-" + name, {
           tooltip: "Toggle " + name,
             text: name.toUpperCase(),
             onClick: function() { editor.execCommand('mceToggleFormat', false, name); },
             onPostRender: function() {
                 var self = this, setup = function() {
                     editor.formatter.formatChanged(name, function(state) {
                         self.active(state);
                     });
                 };
                 editor.formatter ? setup() : editor.on('init', setup);
             }
         })
      });
    });

    tinymce.init({ 
        selector: 'textarea',
        menubar: false,
        plugins: 'link, lists, stylebuttons',
        // skip the default toolbar and specify only what we want here
        toolbar: "bold, italic, underline | link | numlist bullist | style-h1 style-h2 style-h3",
        // always keep changes in sync
        setup: function (editor) {
            editor.on('dirty', function() {
                tinymce.triggerSave();
                $('form').trigger('checkform.areYouSure');
            })
            editor.on('change', function () {
                tinymce.triggerSave();
            });
        }
    });
}




// init the "handsontable" used on the Job Postings section
function initHot() {
    let container = document.getElementById('grid');

    // check if there is contributor data associated
    // If there is, use it to init the table, and also update the hidden input
    // we will update the inputs just after instantiating the grid (see below)
    let data = null;
    if (CONTRIBUTORS_DATA.length) {
        data = [];
        CONTRIBUTORS_DATA.forEach(function(d) {
            let row = [d.fields.contributor_name, d.fields.contributor_institution, d.fields.contributor_contribution];
            data.push(row);
        })
        console.log(data);
    } 

    CONFIG['hot'] = new Handsontable(container, {
        data: data,
        rowHeaders: false,
        colHeaders: ['name','institution', 'contribution'],
        filters: false,
        dropdownMenu: true,
        stretchH: 'all',
        startCols: CONFIG.gridcols,
        startRows: CONFIG.gridrows,
        licenseKey: 'non-commercial-and-evaluation',

        // events
        afterChange: function(changes, source) {
            // this is triggered on load, which we don't really want
            // we only want it after there's a real change
            if (!CONFIG.firstLoad) updateGridData(this);
        },
        afterRemoveRow: function() {
            updateGridData(this);
        },
        afterRemoveCol: function() {
            updateGridData(this);
        },
        afterCreateCol: function() {
            updateGridData(this);
        },
        afterCreateRow: function() {
            updateGridData(this);
        }
    });

    // all set, final step: update the inputs
    if (data) updateGridData(CONFIG['hot']);
}

// update the HOT grids 
function updateGridData(grid) {
    let data = grid.getData();
    // 1) check sub-arrays for blank rows (where every cell was left blank and submitted), and remove them
    data = data.filter(function(d) {
        return d.some(element => element != null);
    });
    // 2) replace nulls with "" (this would most likely represent a blank column, which we can't easily remove)
    data.forEach(function(row) {
        // inner array, the cells in the row
        row.forEach(function(cell, i) { if (cell == null) row[i] = ''; });
    });

    let jsonstring = JSON.stringify(data);
    // give the hidden input the value of the changed data string 
    let input = $(grid.container).siblings('input[type="hidden"]')
    input.val(jsonstring);

    // keep the row/col inputs in sync with the data actually on the table (e.g. after paste)
    let target = grid.container.parentElement.dataset.grid;
    let rows = grid.countRows();
    $(`input[name="${target}-rows"]`).val(rows);
    let cols = grid.countCols();
    $(`input[name="${target}-columns"]`).val(cols);
}

function addRows() {
    let rows = CONFIG['hot'].countRows();
    CONFIG['hot'].alter('insert_row', rows, 1);
}